module.exports = __webpack_public_path__ + "img/mp4.972f9846.svg";